// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__tSAgC","requiredAsterisk":"Info_requiredAsterisk__2jJ08"};